import React from 'react'
import {defineMessages, FormattedList, useIntl} from 'react-intl'

import {Text} from '@daedalus/atlas/Text'
import {BreakdownType} from '@daedalus/core/src/api-types/bovio/response/booking'

const otherFeesMessages = defineMessages({
  [BreakdownType.CityTax]: {
    id: 'rate.cityTax',
    defaultMessage: 'City tax'
  },
  [BreakdownType.CleaningFee]: {
    id: 'rate.cleaningFee',
    defaultMessage: 'Cleaning fee'
  },
  [BreakdownType.DestinationFee]: {
    id: 'rate.destinationFee',
    defaultMessage: 'Destination fee'
  },
  [BreakdownType.EnvironmentFee]: {
    id: 'rate.environmentFee',
    defaultMessage: 'Environment fee'
  },
  [BreakdownType.GoodsAndServicesTax]: {
    id: 'rate.goodsAndServicesTax',
    defaultMessage: 'Goods and services tax'
  },
  [BreakdownType.GovernmentTax]: {
    id: 'rate.governmentTax',
    defaultMessage: 'Government tax'
  },
  [BreakdownType.MunicipalityFee]: {
    id: 'rate.municipalityFee',
    defaultMessage: 'Municipality fee'
  },
  [BreakdownType.TourismFee]: {
    id: 'rate.tourismFee',
    defaultMessage: 'Tourism fee'
  },
  [BreakdownType.ServiceCharge]: {
    id: 'rate.serviceCharge',
    defaultMessage: 'Service charge'
  },
  [BreakdownType.ResortFee]: {
    id: 'rate.resortFee',
    defaultMessage: 'Resort fee'
  },
  AdditionalCharges: {
    id: 'rate.additionalCharges',
    defaultMessage: 'Additional charges'
  }
})

export const TranslatedOtherFees = ({
  elements
}: {
  elements: BreakdownType[]
}) => {
  const intl = useIntl()
  const hasAdditionalCharges = elements.some(
    element => !(element in otherFeesMessages)
  )

  const translatedValues = [
    ...elements.reduce((acc, element) => {
      if (element in otherFeesMessages) {
        return [
          ...acc,
          intl.formatMessage(
            otherFeesMessages[element as keyof typeof otherFeesMessages]
          )
        ]
      }
      return acc
    }, [] as string[]),
    ...(hasAdditionalCharges
      ? [intl.formatMessage(otherFeesMessages.AdditionalCharges)]
      : [])
  ]
  return (
    <div>
      <Text variant="bodyS">
        <FormattedList style="narrow" value={translatedValues} />
      </Text>
    </div>
  )
}
